<template>
  <div class="flex-container">
    <div class="flex-child">
      <Listbox class="list-box" v-model="selectedSideBar" :options="sidebarList" optionLabel="name"
        @change="handleSideBarChange" @click="$emit('reset-confirmation')" />
    </div>
    <div class="flex-child-component">
      <component :is="selectedComponent" :componentProps="shouldPassProps ? componentProps : {}"
        :key="selectedSideBar?.code" @form-change="$emit('form-change')"
        @reset-confirmation="$emit('reset-confirmation')" />
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, defineEmits, ref } from 'vue'
import PhysicianScheduleAdmin from './PhysicianScheduleAdmin.vue'
import ConfigTumorBoard from './ConfigTumorBoard'
import AdminRecordScreen from './AdminRecordScreen'

defineEmits(['form-change', 'reset-confirmation'])

const selectedSideBar = ref({ name: 'Tumor Board', code: 'TB' })
const previousSelectedSideBar = ref({})
const sidebarList = ref([
  { name: 'Tumor Board', code: 'TB' },
  { name: 'Physician Specialty', code: 'PSPEC' },
  { name: 'Physician Schedule', code: 'PS' },
  { name: 'Discussion', code: 'DS' },
  { name: 'Clinical Stage', code: 'CS' },
  { name: 'Referrals', code: 'RF' },
  { name: 'Recommendations', code: 'RC' },
])

const scLookup = {
  'PS': PhysicianScheduleAdmin,
  'TB': ConfigTumorBoard,
  'PSPEC': AdminRecordScreen,
  'DS': AdminRecordScreen,
  'CS': AdminRecordScreen,
  'RF': AdminRecordScreen,
  'RC': AdminRecordScreen,
}
const selectedComponent = computed(() => scLookup[selectedSideBar.value?.code])

const cpLookup = {
  'PSPEC': { adminSideBarHeading: 'Physician Specialty', recordName: 'name', recordApi: 'departments', recordId: 'dept' },
  'DS': { adminSideBarHeading: 'Discussions', recordName: 'discussion', recordApi: 'discussions', recordId: 'discussion' },
  'CS': { adminSideBarHeading: 'Clinical Staging', recordName: 'stage', recordApi: 'tumorstages', recordId: 'stage' },
  'RF': { adminSideBarHeading: 'Referrals', recordName: 'referral', recordApi: 'referrals', recordId: 'referral' },
  'RC': { adminSideBarHeading: 'Recommendations', recordName: 'recommendation', recordApi: 'recommendations', recordId: 'recommendation' },
}
const componentsNeedingProps = ['PSPEC', 'DS', 'CS', 'RF', 'RC']

const componentProps = computed(() => cpLookup[selectedSideBar.value?.code])
const shouldPassProps = computed(() => componentsNeedingProps.includes(selectedSideBar.value?.code))

const handleSideBarChange = (event) => {
  selectedSideBar.value = event.value || previousSelectedSideBar.value
  previousSelectedSideBar.value = selectedSideBar.value
}
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
}

.flex-child {
  text-align: left;
}

.flex-child-component {
  text-align: left;
  margin-left: 3%;
  width: 75%;
  min-width: 600px;
}

.list-box {
  width: 100%;
  height: 100%;
}

.p-listbox {
  border-radius: 0;
  border: none;
  border-right: 1px solid var(--Grey300);
  height: 100%;
  background-color: var(--Grey100);
  font-size: 0.9rem;
}
</style>
